var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame1Light(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 535,
    height: 161,
    viewBox: "0 0 535 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_222_10648)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 403.516,
    y: 123.53,
    width: 154.149,
    height: 88.4615,
    fill: "url(#paint0_linear_222_10648)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M469.849 99.1998C474.619 97.7635 479.702 97.728 484.492 99.0973L550.162 117.871C555.936 119.522 555.973 127.691 550.215 129.394L484.725 148.762C479.79 150.221 474.533 150.183 469.619 148.653L407.704 129.368C402.055 127.609 402.093 119.6 407.759 117.894L469.849 99.1998Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M370.555 -7.57328C368.947 -7.57328 367.383 -7.39737 365.875 -7.07067L361.345 -12.0088L352.217 -6.7377L354.227 -0.341999C352.129 1.97 350.514 4.72176 349.54 7.76882L343 9.22012V19.7623L349.54 21.2136C350.514 24.2544 352.129 27.0124 354.227 29.3244L352.217 35.7201L361.345 40.9912L365.875 36.0531C367.383 36.3798 368.953 36.5557 370.555 36.5557C372.158 36.5557 373.728 36.3798 375.236 36.0531L379.766 40.9912L388.894 35.7201L386.884 29.3244C388.982 27.0187 390.597 24.2607 391.571 21.2136L398.111 19.7623V9.22012L391.571 7.76882C390.597 4.72804 388.982 1.97 386.884 -0.341999L388.894 -6.7377L379.766 -12.0088L375.236 -7.07067C373.728 -7.39737 372.158 -7.57328 370.555 -7.57328ZM380.821 14.4912C380.821 20.1644 376.222 24.757 370.555 24.757C364.889 24.757 360.29 20.1581 360.29 14.4912C360.29 8.82431 364.889 4.22544 370.555 4.22544C376.222 4.22544 380.821 8.82431 380.821 14.4912Z",
    fill: "url(#paint1_linear_222_10648)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M375.062 11.1276C373.204 8.64341 369.684 8.13557 367.2 9.9933C364.716 11.851 364.208 15.3708 366.066 17.855C367.923 20.3392 371.443 20.847 373.927 18.9893C376.411 17.1316 376.919 13.6118 375.062 11.1276Z",
    fill: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M385.401 14.4926C385.401 22.6788 378.742 29.3384 370.555 29.3384C362.369 29.3384 355.71 22.6788 355.71 14.4926C355.71 6.30637 362.369 -0.353189 370.555 -0.353189C378.742 -0.353189 385.401 6.30637 385.401 14.4926ZM356.162 14.4926C356.162 22.4275 362.62 28.886 370.555 28.886C378.49 28.886 384.949 22.4275 384.949 14.4926C384.949 6.55767 378.49 0.0991573 370.555 0.0991573C362.62 0.0991573 356.162 6.55767 356.162 14.4926Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M306 66.8904C307.109 66.8904 308.188 66.7691 309.227 66.5438L312.351 69.9488L318.645 66.3142L317.259 61.9043C318.706 60.3101 319.819 58.4127 320.49 56.3117L325 55.311V48.042L320.49 47.0413C319.819 44.9446 318.706 43.0429 317.259 41.4487L318.645 37.0388L312.351 33.4043L309.227 36.8092C308.188 36.584 307.105 36.4627 306 36.4627C304.895 36.4627 303.812 36.584 302.773 36.8092L299.649 33.4043L293.355 37.0388L294.741 41.4487C293.294 43.0386 292.181 44.9403 291.51 47.0413L287 48.042V55.311L291.51 56.3117C292.181 58.4084 293.294 60.3101 294.741 61.9043L293.355 66.3142L299.649 69.9488L302.773 66.5438C303.812 66.7691 304.895 66.8904 306 66.8904ZM298.922 51.6765C298.922 47.7648 302.093 44.5981 306 44.5981C309.907 44.5981 313.078 47.7691 313.078 51.6765C313.078 55.584 309.907 58.755 306 58.755C302.093 58.755 298.922 55.584 298.922 51.6765Z",
    fill: "url(#paint2_linear_222_10648)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.893 53.9955C304.174 55.7084 306.601 56.0586 308.314 54.7776C310.027 53.4967 310.377 51.0697 309.096 49.3568C307.815 47.6439 305.388 47.2938 303.675 48.5747C301.962 49.8556 301.612 52.2826 302.893 53.9955Z",
    fill: "#D7D7D7"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.8
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M295.764 51.6754C295.764 46.0309 300.355 41.439 306 41.439C311.645 41.439 316.236 46.0309 316.236 51.6754C316.236 57.32 311.645 61.9118 306 61.9118C300.355 61.9118 295.764 57.32 295.764 51.6754ZM315.925 51.6754C315.925 46.2041 311.471 41.7509 306 41.7509C300.529 41.7509 296.076 46.2041 296.076 51.6754C296.076 57.1467 300.529 61.5999 306 61.5999C311.471 61.5999 315.925 57.1467 315.925 51.6754Z",
    fill: "white"
  })))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M541.927 61.124V63.3058C541.927 72.1763 534.733 79.3705 525.863 79.3705H437.166C428.296 79.3705 421.101 72.1763 421.101 63.3058V56.2465C421.101 43.442 431.075 32.5666 443.872 32.1032C445.818 32.0358 447.713 32.2043 449.533 32.575C454.065 17.7655 467.838 6.99121 484.138 6.99121H484.324C487.71 7.00806 490.979 7.48823 494.087 8.37275C495.283 8.71814 496.446 9.11407 497.592 9.57739C504.575 12.3657 510.489 17.2854 514.524 23.5191C518.197 29.1801 520.328 35.9277 520.328 43.1808V43.2061C521.415 43.0039 522.535 42.886 523.681 42.886C533.756 42.886 541.927 51.0573 541.927 61.124Z",
    fill: "url(#paint3_linear_222_10648)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M422.508 110.261H418.38V90.5483H450.072V79.3696H454.199V94.6761H422.508V110.261Z",
    fill: "#4671F6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M543.991 108.744H539.863V89.4279H512.022V79.3696H516.15V85.3001H543.991V108.744Z",
    fill: "#4671F6"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M467.947 79.3696H463.82V110.261H467.947V79.3696Z",
    fill: "#4671F6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M501.121 79.3696H496.993V127.749H501.121V79.3696Z",
    fill: "#4671F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M499.049 133.444C502.608 133.444 505.493 130.559 505.493 127C505.493 123.44 502.608 120.555 499.049 120.555C495.49 120.555 492.605 123.44 492.605 127C492.605 130.559 495.49 133.444 499.049 133.444Z",
    fill: "#4671F6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M465.884 115.189C469.443 115.189 472.328 112.304 472.328 108.745C472.328 105.186 469.443 102.3 465.884 102.3C462.324 102.3 459.439 105.186 459.439 108.745C459.439 112.304 462.324 115.189 465.884 115.189Z",
    fill: "#4671F6"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M420.444 115.189C424.004 115.189 426.889 112.304 426.889 108.745C426.889 105.186 424.004 102.3 420.444 102.3C416.885 102.3 414 105.186 414 108.745C414 112.304 416.885 115.189 420.444 115.189Z",
    fill: "#4671F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_222_10648",
    x1: 557.664,
    y1: 167.761,
    x2: 403.516,
    y2: 167.761,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_222_10648",
    x1: 345.422,
    y1: 60.8662,
    x2: 405.047,
    y2: -36.4703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_222_10648",
    x1: 323.33,
    y1: 19.7001,
    x2: 282.218,
    y2: 86.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FCFBFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_222_10648",
    x1: 421.101,
    y1: 107.847,
    x2: 494.327,
    y2: -61.8706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5780FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.228522,
    stopColor: "#698EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635417,
    stopColor: "#A4BCFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BCFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_222_10648"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 535,
    height: 161,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame1Light);
export default __webpack_public_path__ + "static/media/frame-1-light.ec92b9989f72c6d29f27714da8eeecb0.svg";
export { ForwardRef as ReactComponent };